<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative" :class="{ 'support-navbar': isStudentSupportReadOnly }">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar"/>

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992"/> -->
        <dummy-bar v-if="!isStudentSupportReadOnly"/>
        <student-support-status v-if="isStudentSupportReadOnly"/>

        <vs-spacer v-if="!isStudentSupportReadOnly"/>

        <!-- <i18n style="margin-right:24px"/> -->

        <!-- <notification-drop-down/>-->

        <profile-drop-down/>

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import DummyBar            from './components/DummyBar.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import StudentSupportStatus from './components/StudentSupportStatus.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    DummyBar,
    ProfileDropDown,
    StudentSupportStatus
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else                                              return 'navbar-full'
      //else if (this.verticalNavMenuWidth)               return 'navbar-full'
      //else return null
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

<style lang="scss">
// Support only: keep the navbar sticky but in document flow so wrapped rows reserve their own height.
.support-navbar {
  position: sticky;
  top: 0;
  z-index: 41001;

  .vx-navbar-wrapper {
    position: relative !important;
    height: auto !important;
    width: 100% !important;
    padding-bottom: 0;
  }
  .vs-con-items { flex-wrap: wrap; gap: .5rem .8rem; }
  .student-support-status { flex: 1 1 20rem; }
  .the-navbar__user-meta {
    flex: 0 1 42%;
    min-width: 0;
    margin-left: auto;
    justify-content: flex-end;
    > div:first-child { min-width: 0; overflow-wrap: anywhere; }
  }
  @media (max-width: 767px) {
    .student-support-status { order: 2; flex: 1 1 100%; }
    .the-navbar__user-meta { flex: 1 1 0; }
  }
}
</style>
